import type { PullStatus } from 'antd-mobile/es/components/pull-to-refresh';
import type { CouponType, CouponStatusMap, ControlItem, ControlStatustem, CouponBackgroundMap, ModalCloseType } from '@/types/credits';

export const COUPON_MAP: Record<CouponType, CouponType> = {
    COUPONS: 'COUPONS',
    FREE_PRODUCTS: 'FREE_PRODUCTS',
    GIFT_CARD: 'GIFT_CARD',
};

export const COUPON_STATUS_MAP: CouponStatusMap = {
    UNUSED: 'UNUSED',
    USED: 'USED',
    EXPIRED: 'EXPIRED',
    REDEEM_FREE_PRODUCTS: 'REDEEM_FREE_PRODUCTS',
};

export const controlItems: ControlItem[] = [
    {
        key: 'COUPONS',
        label: 'Discount',
        transKey: 'point_redeem_coupons',
    },
    {
        key: 'FREE_PRODUCTS',
        label: 'Product',
        transKey: 'point_product',
    },
    {
        key: 'GIFT_CARD',
        label: 'Gift Card',
        transKey: 'point_gift_card',
    },
];

export const TAB_KEYS = ['COUPONS', 'FREE_PRODUCTS', 'GIFT_CARD'] as const;

export const statusItems: ControlStatustem[] = [
    {
        key: 'UNUSED',
        label: 'Unused',
        transKey: 'my_coupon_unused',
    },
    {
        key: 'USED',
        label: 'Used',
        transKey: 'my_coupon_used',
    },
    {
        key: 'EXPIRED',
        label: 'Expired',
        transKey: 'my_coupon_expired',
    },
];

export const NORMAL_COUPON_TYPE_IMAGES = {
    COUPONS: '/static/img/credits/coupon_background_discount@2x.png',
    FREE_PRODUCTS: '/static/img/credits/coupon_background_product@2x.png',
    GIFT_CARD: '/static/img/credits/coupon_background_giftcard@2x.png',
};

export const COUPON_STATUS_IMAGES: CouponBackgroundMap = {
    COUPONS: {
        UNUSED: '/static/img/credits/coupon_background_discount@2x.png',
        USED: '/static/img/credits/coupon_background_used@2x.png',
        EXPIRED: '/static/img/credits/coupon_background_expired@2x.png',
    },
    FREE_PRODUCTS: {
        REDEEM_FREE_PRODUCTS: '/static/img/credits/coupon_background_product_unused@2x.png',
    },
    GIFT_CARD: {
        UNUSED: '/static/img/credits/coupon_background_giftcard_unused@2x.png',
        USED: '/static/img/credits/coupon_background_used@2x.png',
        EXPIRED: '/static/img/credits/coupon_background_expired@2x.png',
    },
};

export const statusRecord: Record<PullStatus, string> = {
    pulling: 'device_list_pull_down_to_refresh',
    canRelease: 'device_list_release_to_refresh',
    refreshing: 'device_list_load_more',
    complete: 'device_list_no_more_data',
};

export const DISCOUNT_TYPE = {
    FIXED_AMOUNT: 'fixed_amount',
    PERCENTAGE: 'percentage',
};

export const PREREQUISITE = {
    NONE: 'NONE',
    PRICES: 'PRICES',
    QUANTITY: 'QUANTITY',
};

export const EXPIRE_TYPE = {
    DAY: 'DAY',
    TIME: 'TIME',
};

export const MODAL_CLOSE_TYPE: Record<ModalCloseType, ModalCloseType> = {
    CANCEL: 'CANCEL',
    CLOSE: 'CLOSE',
    SUCCESS: 'SUCCESS',
    FAIL: 'FAIL',
    CONFIRM: 'CONFIRM',
};

export const RewardScenario = {
    REGISTER: `point_register`,
    ACCOUNT_BIND: `ACCOUNT_BIND`,
    WARRANTY: `point_warranty`,
    EDM: `point_subscribe`,
    ACCOUNT_INFO_ICON: `point_pro_picture`,
    ACCOUNT_INFO_NICKNAME: `point_pro_username`,
    ACCOUNT_INFO_NAME: `point_pro_contact_info`,
    ACCOUNT_INFO_BIRTHDAY: `point_pro_birthday`,
    ACCOUNT_INFO_ADDRESS: `point_pro_address`,
    SHOP_SINGLE_PRODUCT: `point_purchase`,
    SHOP_SINGLE_ORDER: `point_purchase`,
    SHOP_ACCUM_MONEY: `point_purchase`,
    SHOP_ACCUM_COUNT: `point_purchase`,
    COUPONS_PRODUCTS_FIXED: `point_redeem_coupons`,
    COUPONS_PRODUCTS_PERCENTAGE: `point_redeem_coupons`,
    COUPONS_ORDERS_FIXED: `point_redeem_coupons`,
    COUPONS_ORDERS_PERCENTAGE: `point_redeem_coupons`,
    FREE_SHIPPING: `point_question_reward`,
    FREE_PRODUCTS: `point_product`,
    GIFT_CARD: `point_gift_card`,
    THIRD_COUPONS: `point_third_coupons`,
    REFUNDED: `point_refund`,
    EXPIRED: `point_expired`,
    MANUAL_PLUS: `point_manually_add`,
    MANUAL_MINUS: `point_manually_deducted`,
    DRAW_PLUS: `point_draw_plus`,
    DRAW_MINUS: `point_draw_minus`,
    WARRANTY_MINUS: `point_warranty_minus`,
    CREDITS_DAY_MINUS: `point_credits_day_minus`,
    QUESTION_REWARD: `point_question_reward`,
} as const;

export const PAGE_SIZE = 10;

export const SUCCESS_CODE = '0';

export const THRESHOLD = 30;
